import React from 'react';

const CONNECTFooter = () => <footer id="GlobalFooter" />;
export default CONNECTFooter;
